// extracted by mini-css-extract-plugin
export default {"background":"NotFound_background__T+ZM4"};